<template>
    <v-autocomplete
            v-model="selected"
            :items="items"
            cache-items
            :loading="loading"
            :search-input.sync="search"
            chips
            item-text="nombre_completo"
            item-value="id"
            label="Repartidor:"
            placeholder="Nombre del repartidor"
            prepend-icon="mdi-truck"
            clearable
            multiple
            @click:clear="$emit('selected',[])"
    />
</template>

<script>
    import axios from 'axios';

    export default {
        name: "SearchRepartidoresInput",
        data() {
            return {
                selected: [],
                items: [],
                loading: false,
                search: ''
            }
        },
        mounted(){
            this.loadData();
        },
        watch: {
            search(val) {
                // Items have already been requested
                if (this.loading || (typeof (val) !== 'string' || (typeof (val) === 'string' && val.length < 1))) {
                    return
                }

                // Lazily load input items
                this.loadData();
            },
            selected(val) {
                if (val.length < 1) {
                    return
                }

                this.$emit('selected', this.selected);
            }
        },
        methods: {
            loadData() {
                this.loading = true;
                axios.get('/api/usuarios/search', {params: {is_list: 1, search: this.search}})
                    .then(({data}) => {
                        this.items = data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
</script>

<style scoped>

</style>
